import { em, math } from 'polished'
import styled from 'styled-components'

export const Item = styled.div`
  position: absolute;

  &.item-0 {
    top: 10%;
  }

  &.item-1 {
    top: 26%;
  }

  &.item-2 {
    top: 54%;

    ${p => p.theme.mq.upXl} {
      top: 55%;
    }
  }

  &.item-3 {
    top: 75%;
  }
`

export const LineWrapper = styled(Item)`
  display: inline-block;
  transform: translateX(-100%);
  height: ${p => math(`${em(16)} * ${p.theme.typography.baseLh}`)};

  &.line-0 {
    width: 20%;
  }

  &.line-1 {
    width: 20%;
  }

  &.line-2 {
    width: 30%;
  }

  &.line-3 {
    width: 25%;
  }
`
